(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["module_products"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initRelatedProductsArrows() {
      var sliders = document.querySelectorAll('[data-related-products-slider]');
      if (!sliders.length) return;

      sliders.forEach(function (slider) {
        var track = slider.querySelector('[data-related-products-track]');
        var prevButton = slider.querySelector('[data-related-products-prev]');
        var nextButton = slider.querySelector('[data-related-products-next]');
        var nav = slider.querySelector('.featured-products-nav');

        if (!track || !prevButton || !nextButton || !nav) return;

        function getStepSize() {
          var firstCard = track.querySelector('.product-card');
          if (!firstCard) return Math.max(track.clientWidth * 0.85, 280);

          var cardWidth = firstCard.getBoundingClientRect().width;
          var trackStyles = window.getComputedStyle(track);
          var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
          return Math.max(cardWidth + gap, 1);
        }

        function updateButtons() {
          var maxScrollLeft = track.scrollWidth - track.clientWidth;
          var hasOverflow = maxScrollLeft > 4;

          nav.hidden = !hasOverflow;
          if (!hasOverflow) return;

          prevButton.disabled = track.scrollLeft <= 4;
          nextButton.disabled = track.scrollLeft >= maxScrollLeft - 4;
        }

        prevButton.addEventListener('click', function () {
          track.scrollBy({ left: -getStepSize(), behavior: 'smooth' });
        });

        nextButton.addEventListener('click', function () {
          track.scrollBy({ left: getStepSize(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
        updateButtons();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRelatedProductsArrows);
    } else {
      initRelatedProductsArrows();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partial_announcement-bar"] && !Shopify.designMode) return;
  try {
    
  if($('.marquee').length) {
    Marquee3k.init({
      selector: 'marquee',
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["partial_related-products"]) return;
  try {
    
  (function () {
    function initRelatedProductsArrows() {
      var sliders = document.querySelectorAll('[data-related-products-slider]');
      if (!sliders.length) return;

      sliders.forEach(function (slider) {
        var track = slider.querySelector('[data-related-products-track]');
        var prevButton = slider.querySelector('[data-related-products-prev]');
        var nextButton = slider.querySelector('[data-related-products-next]');
        var nav = slider.querySelector('.featured-products-nav');

        if (!track || !prevButton || !nextButton || !nav) return;

        function getStepSize() {
          var firstCard = track.querySelector('.product-card');
          if (!firstCard) return Math.max(track.clientWidth * 0.85, 280);

          var cardWidth = firstCard.getBoundingClientRect().width;
          var trackStyles = window.getComputedStyle(track);
          var gap = parseFloat(trackStyles.columnGap || trackStyles.gap || '0') || 0;
          return Math.max(cardWidth + gap, 1);
        }

        function updateButtons() {
          var maxScrollLeft = track.scrollWidth - track.clientWidth;
          var hasOverflow = maxScrollLeft > 4;

          nav.hidden = !hasOverflow;
          if (!hasOverflow) return;

          prevButton.disabled = track.scrollLeft <= 4;
          nextButton.disabled = track.scrollLeft >= maxScrollLeft - 4;
        }

        prevButton.addEventListener('click', function () {
          track.scrollBy({ left: -getStepSize(), behavior: 'smooth' });
        });

        nextButton.addEventListener('click', function () {
          track.scrollBy({ left: getStepSize(), behavior: 'smooth' });
        });

        track.addEventListener('scroll', updateButtons, { passive: true });
        window.addEventListener('resize', updateButtons);
        updateButtons();
      });
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initRelatedProductsArrows);
    } else {
      initRelatedProductsArrows();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["template_swym-wishlist"]) return;
  try {
    
  (function () {

    function getHandleFromUrl(url) {
      if (!url) return '';
      try {
        var parsed = new URL(url, window.location.origin);
        var match = parsed.pathname.match(/\/products\/([^\/\?]+)/);
        return match && match[1] ? match[1] : '';
      } catch (e) {
        return '';
      }
    }

    function money(cents) {
      var value = Number(cents);
      if (Number.isNaN(value)) return '';

      try {
        if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          return window.Shopify.formatMoney(value);
        }
      } catch (e) {}

      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR',
        }).format(value / 100);
      } catch (e2) {
        return (value / 100).toFixed(2) + ' EUR';
      }
    }

    function dedupeByHandle(items) {
      var seen = {};
      return items.filter(function (item) {
        var handle = getHandleFromUrl(item.du);
        if (!handle || seen[handle]) return false;
        seen[handle] = true;
        return true;
      });
    }

    function fetchProductJson(handle) {
      return fetch('/products/' + handle + '.js')
        .then(function (res) {
          if (!res.ok) return null;
          return res.json();
        })
        .catch(function () { return null; });
    }

    function fetchRenderedProductCard(handle) {
      return fetch('/products/' + handle + '?section_id=template_swym-wishlist-card')
        .then(function (res) {
          if (!res.ok) return '';
          return res.text();
        })
        .then(function (html) {
          if (!html) return '';
          var wrapper = document.createElement('div');
          wrapper.innerHTML = html;
          var card = wrapper.querySelector('.product-card');
          return card ? card.outerHTML : '';
        })
        .catch(function () { return ''; });
    }

    function renderServerCards(cardsHtml) {
      var grid = document.getElementById('wishlist-product-grid');
      if (!grid) return;
      var empty = document.getElementById('wishlist-empty-state');
      if (empty) empty.remove();
      grid.removeAttribute('hidden');
      grid.innerHTML = cardsHtml.join('');
    }

    function syncSwymButtons(swat) {
      var gridSelector = '#wishlist-product-grid';
      if (!swat || typeof swat.initializeActionButtons !== 'function') return;

      swat.initializeActionButtons(gridSelector);

      // Re-run shortly after initial render in case Swym UI bundle binds asynchronously.
      setTimeout(function () {
        swat.initializeActionButtons(gridSelector);
      }, 250);
      setTimeout(function () {
        swat.initializeActionButtons(gridSelector);
      }, 800);
    }

    function ensureEmptyStateMessage() {
      var page = document.getElementById('masscob-wishlist-page');
      var grid = document.getElementById('wishlist-product-grid');
      if (!page || !grid) return;

      var cardsCount = grid.querySelectorAll('.product-card').length;
      var empty = document.getElementById('wishlist-empty-state');

      if (cardsCount === 0) {
        grid.setAttribute('hidden', '');
        page.classList.add('is-empty');
        if (!empty) {
          empty = document.createElement('p');
          empty.id = 'wishlist-empty-state';
          empty.textContent = 'Your wishlist is empty.';
          page.appendChild(empty);
        }
      } else {
        page.classList.remove('is-empty');
        if (empty) empty.remove();
      }
    }

    function initWishlistRemovalFromGrid() {
      var grid = document.getElementById('wishlist-product-grid');
      if (!grid || grid.dataset.swymRemovalBound === 'true') return;
      grid.dataset.swymRemovalBound = 'true';

      grid.addEventListener('click', function (event) {
        var button = event.target.closest('.masscob-swym-btn');
        if (!button) return;

        // Only remove card when user is toggling OFF an already wishlisted item.
        var wasWishlisted = button.classList.contains('swym-added');
        if (!wasWishlisted) return;

        var card = button.closest('.product-card');
        if (!card) return;

        var attempts = 0;
        var maxAttempts = 15;
        var interval = setInterval(function () {
          attempts += 1;
          var stillWishlisted = button.classList.contains('swym-added');
          if (!stillWishlisted) {
            clearInterval(interval);
            card.remove();
            ensureEmptyStateMessage();
            return;
          }

          if (attempts >= maxAttempts) {
            clearInterval(interval);
          }
        }, 150);
      });
    }

    function renderGrid(products) {
      var grid = document.getElementById('wishlist-product-grid');
      if (!grid) return;

      var empty = document.getElementById('wishlist-empty-state');
      var page = document.getElementById('masscob-wishlist-page');

      if (!products.length) {
        grid.setAttribute('hidden', '');
        grid.innerHTML = '';
        if (page) page.classList.add('is-empty');
        if (!empty && page) {
          empty = document.createElement('p');
          empty.id = 'wishlist-empty-state';
          empty.textContent = 'Your wishlist is empty.';
          page.appendChild(empty);
        }
        return;
      }

      if (page) page.classList.remove('is-empty');
      if (empty) empty.remove();
      grid.removeAttribute('hidden');

      grid.innerHTML = products.map(function (product) {
        var href = '/products/' + product.handle;
        var image = product.featured_image || '';
        var title = product.title || '';
        var soldOut = !product.available;
        var hasSale = Number(product.compare_at_price) > Number(product.price);
        var productId = product.id;
        var firstVariantId = product.variants && product.variants.length ? product.variants[0].id : '';

        return (
          '<div class="product-card' + (soldOut ? ' sold-out' : '') + '">' +
          '  <div class="product-card-wishlist-button-container">' +
          '    <button aria-label="Add to Wishlist" data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product masscob-swym-btn product_' + productId + '" data-swaction="addToWishlist" data-product-id="' + productId + '" data-variant-id="' + firstVariantId + '" data-product-url="' + window.location.origin + href + '" type="button">' +
          '      <svg width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8.5 0.5V12.5C8.44 12.44 4.49 8.54 4.49 8.54L0.5 12.5V0.5H8.5Z" stroke="currentColor" fill="none" stroke-miterlimit="10"></path></svg>' +
          '    </button>' +
          '  </div>' +
          '  <div class="product-card-media-container">' +
          '    <a href="' + href + '" class="product-card-link-media">' +
          '      <img src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy">' +
          '    </a>' +
          '  </div>' +
          '  <div class="product-card-info-container">' +
          '    <div class="product-card-info-text">' +
          '      <div class="product-card-title">' + title + '</div>' +
          '      <div class="product-card-price">' +
          (soldOut
            ? 'Sold out'
            : hasSale
              ? '<s class="product-card-compare-price">' + money(product.compare_at_price) + '</s> <span class="product-card-price price-on-sale">' + money(product.price) + '</span>'
              : money(product.price)) +
          '      </div>' +
          '    </div>' +
          '  </div>' +
          '</div>'
        );
      }).join('');

      if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
        window._swat.initializeActionButtons('#wishlist-product-grid');
      }
    }

    function renderGridFromSwymItems(items) {
      var grid = document.getElementById('wishlist-product-grid');
      if (!grid) return;

      var empty = document.getElementById('wishlist-empty-state');
      var page = document.getElementById('masscob-wishlist-page');

      if (!items.length) {
        grid.setAttribute('hidden', '');
        grid.innerHTML = '';
        if (page) page.classList.add('is-empty');
        if (!empty && page) {
          empty = document.createElement('p');
          empty.id = 'wishlist-empty-state';
          empty.textContent = 'Your wishlist is empty.';
          page.appendChild(empty);
        }
        return;
      }

      if (page) page.classList.remove('is-empty');
      if (empty) empty.remove();
      grid.removeAttribute('hidden');

      grid.innerHTML = items.map(function (item) {
        var href = item.du || '#';
        var image = item.iu || '';
        var title = item.dt || '';
        var productId = item.empi || item.product_id || '';
        var variantId = item.epi || item.variant_id || '';
        var price = item.pr != null ? money(item.pr) : '';

        return (
          '<div class="product-card">' +
          '  <div class="product-card-wishlist-button-container">' +
          '    <button aria-label="Add to Wishlist" data-with-epi="true" class="swym-button swym-add-to-wishlist-view-product masscob-swym-btn product_' + productId + '" data-swaction="addToWishlist" data-product-id="' + productId + '" data-variant-id="' + variantId + '" data-product-url="' + href + '" type="button">' +
          '      <svg width="9" height="14" viewBox="0 0 9 14" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false"><path d="M8.5 0.5V12.5C8.44 12.44 4.49 8.54 4.49 8.54L0.5 12.5V0.5H8.5Z" stroke="currentColor" fill="none" stroke-miterlimit="10"></path></svg>' +
          '    </button>' +
          '  </div>' +
          '  <div class="product-card-media-container">' +
          '    <a href="' + href + '" class="product-card-link-media">' +
          '      <img src="' + image + '" alt="' + title.replace(/"/g, '&quot;') + '" loading="lazy">' +
          '    </a>' +
          '  </div>' +
          '  <div class="product-card-info-container">' +
          '    <div class="product-card-info-text">' +
          '      <div class="product-card-title">' + title + '</div>' +
          '      <div class="product-card-price">' + price + '</div>' +
          '    </div>' +
          '  </div>' +
          '</div>'
        );
      }).join('');

      if (window._swat && typeof window._swat.initializeActionButtons === 'function') {
        window._swat.initializeActionButtons('#wishlist-product-grid');
      }
    }

    function fetchWishlistItems(swat, onSuccess, onError) {
      swat.fetchLists({
        callbackFn: function (lists) {
          var allItems = [];
          (lists || []).forEach(function (list) {
            if (Array.isArray(list.listcontents)) {
              allItems = allItems.concat(list.listcontents);
            }
          });
          if (allItems.length) {
            onSuccess(allItems);
            return;
          }
          swat.fetch(function (items) {
            onSuccess(items || []);
          }, function () {
            onError();
          });
        },
        errorFn: function () {
          swat.fetch(function (items) {
            onSuccess(items || []);
          }, function () {
            onError();
          });
        }
      });
    }

    function initCustomWishlist(swat) {
      fetchWishlistItems(
        swat,
        function (items) {
          var unique = dedupeByHandle(items || []);
          var handles = unique.map(function (item) { return getHandleFromUrl(item.du); }).filter(Boolean);
          if (!handles.length) {
            renderGridFromSwymItems(items || []);
            return;
          }

          Promise.all(handles.map(fetchProductJson)).then(function (products) {
            var validProducts = products.filter(Boolean);
            Promise.all(handles.map(fetchRenderedProductCard)).then(function (cardsHtml) {
              var validCards = cardsHtml.filter(Boolean);
              if (validCards.length) {
                renderServerCards(validCards);
                syncSwymButtons(swat);
                initWishlistRemovalFromGrid();
                window.dispatchEvent(new Event('resize'));
                return;
              }

              if (validProducts.length) {
                renderGrid(validProducts);
                syncSwymButtons(swat);
                initWishlistRemovalFromGrid();
                window.dispatchEvent(new Event('resize'));
                return;
              }

              renderGridFromSwymItems(items || []);
              syncSwymButtons(swat);
              initWishlistRemovalFromGrid();
              window.dispatchEvent(new Event('resize'));
            });
          });
        },
        function () {
          renderGrid([]);
          syncSwymButtons(swat);
        }
      );
    }

    window.SwymCallbacks = window.SwymCallbacks || [];
    window.SwymCallbacks.push(initCustomWishlist);
  })();

  } catch(e) { console.error(e); }
})();
})();
